import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "reference-info" }
const _hoisted_2 = { class: "reference--name" }
const _hoisted_3 = {
  key: 0,
  class: "reference--position"
}
const _hoisted_4 = {
  key: 1,
  class: "reference--company"
}
const _hoisted_5 = {
  key: 2,
  class: "reference--relationship"
}
const _hoisted_6 = { class: "reference--dates" }
const _hoisted_7 = {
  key: 3,
  class: "reference--address"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 4,
  class: "reference--email"
}
const _hoisted_11 = {
  key: 5,
  class: "reference--telephone"
}
const _hoisted_12 = {
  key: 6,
  class: "reference--contact"
}
const _hoisted_13 = { key: 7 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-h5" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 1,
  class: "grid button-bar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_UserReferenceProgress = _resolveComponent("UserReferenceProgress")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_UserReferenceForm = _resolveComponent("UserReferenceForm")!
  const _component_DynamicList = _resolveComponent("DynamicList")!

  return (_openBlock(), _createBlock(_component_DynamicList, {
    items: _ctx.references,
    modalTitle: "references.reference-details",
    newFunc: _ctx.createNewReference,
    limit: _ctx.limit,
    buttonText: `references.add-new-${_ctx.referenceType}-reference`,
    saveButtonText: _ctx.saveButtonText,
    canEditItem: _ctx.isReferenceInProgress,
    schema: _ctx.schema,
    readonly: _ctx.disabled,
    overrideDisableSaveButton: _ctx.isReferenceValid,
    onSave: _ctx.handleSave,
    onDelete: _ctx.handleDelete,
    onUpdate: _ctx.handleUpdate,
    allowDismiss: false
  }, {
    item: _withCtx(({ item }) => [
      _createVNode(_component_Card, {
        title: _ctx.getReferenceName(),
        class: "reference-box"
      }, {
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("h6", null, "Reference", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.name), 1),
            (item.employerReference)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.employerReference.referencePosition), 1))
              : _createCommentVNode("", true),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "break" }, null, -1)),
            (item.employerReference)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.employerReference.company), 1))
              : _createCommentVNode("", true),
            (item.characterReference)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.characterReference.howKnown), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, " (" + _toDisplayString(_ctx.formatDate(item.dateFrom)) + " - " + _toDisplayString(item.presentDay
                ? _ctx.translateText("references.view-present-day")
                : _ctx.formatDate(item.dateTo)) + ") ", 1),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "break" }, null, -1)),
            (
              item.employerReference?.address &&
              item.employerReference.address.line1 &&
              item.employerReference.address.postcode
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(item.employerReference.address.line1), 1),
                  (item.employerReference.addressline2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.employerReference.address.line2), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.employerReference.address.city), 1),
                  (item.employerReference.address.county)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.employerReference.address.county), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.employerReference.address.postcode), 1),
                  _createElementVNode("div", null, _toDisplayString(item.employerReference.address.country), 1)
                ]))
              : _createCommentVNode("", true),
            (item.email?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.email), 1))
              : _createCommentVNode("", true),
            (item.telephoneNumber?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.telephoneNumber), 1))
              : _createCommentVNode("", true),
            (item.contactInfo?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.contactInfo), 1))
              : _createCommentVNode("", true),
            (!_ctx.userReference && item.referenceRecord?.completed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.showReference(item.referenceRecord)), ["prevent"]),
                      href: "#",
                      style: {"font-weight":"bold"}
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.showAnswers[item.referenceRecord.id] ? "-" : "+"), 1),
                      _createVNode(_component_TranslatedText, { path: "references.view-completed-reference" })
                    ], 8, _hoisted_14),
                    _cache[0] || (_cache[0] = _createTextVNode("   ", -1))
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_TranslatedText, {
                        path: "references.date-completed",
                        class: "subtitle"
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode("   ", -1)),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(item.referenceRecord.completedDate)), 1)
                    ]),
                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                    (item.employerReference && item.email?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (item.referenceRecord?.dayFrom)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.referenceRecord?.employerReferenceRecord?.userPosition) + " ( " + _toDisplayString(_ctx.createDateString(
                      item.referenceRecord?.yearFrom,
                      item.referenceRecord?.monthFrom,
                      item.referenceRecord?.dayFrom
                    )) + " - " + _toDisplayString(item.referenceRecord?.presentDay
                      ? _ctx.translateText("references.view-present-day")
                      : _ctx.createDateString(
                          item.referenceRecord?.yearTo,
                          item.referenceRecord?.monthTo,
                          item.referenceRecord?.dayTo
                        )) + " ) ", 1))
                            : _createCommentVNode("", true),
                          (_ctx.tenantConfigs.employer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantConfigs.employer, (question, index) => {
                                  return (_openBlock(), _createElementBlock("p", { key: index }, [
                                    _createVNode(_component_TranslatedText, {
                                      path: `references.referee.${question?.key}`,
                                      class: "subtitle"
                                    }, null, 8, ["path"]),
                                    _cache[2] || (_cache[2] = _createTextVNode(":", -1)),
                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(item.referenceRecord?.employerReferenceRecord[
                        question?.field
                      ] ?? `-`), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.characterReference && item.email?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_TranslatedText, {
                            path: "references.is-information-correct",
                            class: "subtitle"
                          }),
                          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                          (
                    item.referenceRecord?.characterReferenceRecord?.confirmed
                  )
                            ? (_openBlock(), _createBlock(_component_TranslatedText, {
                                key: 0,
                                path: "common.yes"
                              }))
                            : (_openBlock(), _createBlock(_component_TranslatedText, {
                                key: 1,
                                path: "common.no"
                              })),
                          (_ctx.tenantConfigs.character)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantConfigs.character, (question, index) => {
                                  return (_openBlock(), _createElementBlock("p", { key: index }, [
                                    _createVNode(_component_TranslatedText, {
                                      path: `references.referee.${question?.key}`,
                                      class: "subtitle"
                                    }, null, 8, ["path"]),
                                    _cache[5] || (_cache[5] = _createTextVNode(":", -1)),
                                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(item.referenceRecord?.characterReferenceRecord[
                        question?.field
                      ] ?? `-`), 1)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, _ctx.showAnswers[item.referenceRecord.id]]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.userReference)
            ? (_openBlock(), _createBlock(_component_UserReferenceProgress, {
                key: 0,
                reference: item,
                userReference: _ctx.userReference
              }, null, 8, ["reference", "userReference"]))
            : _createCommentVNode("", true),
          (!_ctx.userReference && !item?.referenceRecord?.completed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (!item?.referenceRecord?.approved)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      variant: "secondary",
                      size: "sm",
                      text: "Approve",
                      onClick: ($event: any) => (_ctx.handleAdminAction(item, 'Approve'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!item?.referenceRecord?.approved)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      variant: "secondary",
                      size: "sm",
                      text: "Approve and Send",
                      onClick: ($event: any) => (_ctx.handleAdminAction(item, 'Approve and Send'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
              item?.referenceRecord?.approved && !item?.referenceRecord?.sent
            )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      variant: "secondary",
                      size: "sm",
                      text: "Send",
                      onClick: ($event: any) => (_ctx.handleAdminAction(item, 'Send'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
              item?.referenceRecord?.approved &&
              item?.referenceRecord?.sent &&
              !item?.referenceRecord?.completed
            )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 3,
                      variant: "secondary",
                      size: "sm",
                      text: "Resend",
                      onClick: ($event: any) => (_ctx.handleAdminAction(item, 'Resend'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
              item?.referenceRecord?.approved &&
              item?.referenceRecord?.sent &&
              !item?.referenceRecord?.completed
            )
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 4,
                      variant: "secondary",
                      size: "sm",
                      text: "Complete",
                      onClick: ($event: any) => (_ctx.handleAdminAction(item, 'Complete'))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["title"])
    ]),
    modalBody: _withCtx(({ formItem }) => [
      _createElementVNode("p", null, [
        _createVNode(_component_TranslatedText, { path: "references.enter-ammend" })
      ]),
      _createVNode(_component_UserReferenceForm, {
        reference: formItem,
        referenceType: _ctx.referenceType,
        errors: _ctx.errorsRef,
        userReference: _ctx.userReference,
        mandatoryFields: _ctx.mandatoryFields,
        onUpdate: ($event: any) => (_ctx.updateReference($event, formItem))
      }, null, 8, ["reference", "referenceType", "errors", "userReference", "mandatoryFields", "onUpdate"])
    ]),
    _: 1
  }, 8, ["items", "newFunc", "limit", "buttonText", "saveButtonText", "canEditItem", "schema", "readonly", "overrideDisableSaveButton", "onSave", "onDelete", "onUpdate"]))
}